import React from 'react';

function getScoreColor(score) {
  if (score >= 800) return { bg: '#1E6C30', text: '#ffffff' }; // excellent - success
  if (score >= 740) return { bg: '#4d7c0f', text: '#ffffff' }; // very good
  if (score >= 670) return { bg: '#a3a323', text: '#ffffff' }; // good - olive
  if (score >= 580) return { bg: '#DCA114', text: '#1A1A1A' }; // fair - alert
  if (score > 0) return { bg: '#B0200C', text: '#ffffff' };    // poor - destructive
  return { bg: '#B0200C', text: '#ffffff' };                    // zero - destructive
}

/**
 * `flagged` marks a red zone score. The band colours already run warm at the
 * bottom of the range, so the flag reads as a ring around the badge rather
 * than another shade of red — otherwise a flagged "fair" and an unflagged
 * "poor" would look the same at a glance.
 */
export default function ScoreBadge({ score, size = 'md', flagged = false }) {
  const { bg, text } = getScoreColor(score);
  const sizeClasses = size === 'lg'
    ? 'min-w-[56px] h-9 text-base px-3'
    : 'min-w-[48px] h-7 text-sm px-2.5';

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold ${sizeClasses} ${
        flagged ? 'ring-2 ring-offset-2 ring-[#B0200C]' : ''
      }`}
      style={{ backgroundColor: bg, color: text }}
      title={flagged ? 'In the red zone — below the watch list threshold' : undefined}
    >
      {Math.round(score)}
    </span>
  );
}
